module.exports = __webpack_public_path__ + "media/images/thresholds_warning-dda2f09f81f39c989c446f4a35fd3a5a.png";